import { useCallback } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DEFAULT_CALENDAR_START_DATE } from '../../../const';

const getUpdatedTime = (time) => {
    const updatedDate = new Date(time);
    updatedDate.setHours(12);
    updatedDate.setMinutes(0);
    return updatedDate;
};

const DateTimePicker = ({
    control,
    name,
    placeholder,
    customInput = null,
    defaultValue = null,
    showTimePicker = false,
    setValue = () => {},
    isInProfile = false
}) => {
    const propsParam = !!customInput ? { customInput: customInput } : {};
    const { t } = useTranslation();

    const startDate = new Date(DEFAULT_CALENDAR_START_DATE);
    const defValueProps = !!defaultValue ? new Date(defaultValue) : getUpdatedTime(DEFAULT_CALENDAR_START_DATE);
    const timeProps = showTimePicker ? { timeFormat: 'HH:mm', timeIntervals: 15, timeCaption: 'time', showTimeSelect: true } : {};

    const validateDate = useCallback((selectDate) => {
        if (selectDate > new Date()) {
            return t('labels.dateSelect');
        }
        return true;
    }, []);

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defValueProps}
            render={({ field: { onChange, value } }) => {
                const updatedDate = getUpdatedTime(value || startDate);
                const selectedValue = showTimePicker ? value : updatedDate;

                return (
                    <DatePicker
                        selected={selectedValue || startDate}
                        onChange={onChange}
                        dateFormat={isInProfile ? 'MM-dd-yyyy h:mm aa' : 'MM-dd-yyyy'}
                        placeholderText={placeholder}
                        maxDate={new Date()}
                        onBlur={() => {
                            setValue(name, value || updatedDate);
                        }}
                        rules={{ validate: validateDate }}
                        {...propsParam}
                        {...timeProps}
                    />
                );
            }}
            rules={{
                required: t('labels.selectDate')
            }}
        />
    );
};

export default DateTimePicker;
